import CompanyFooter from "@/components/CompanyFooter";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#27272A] pt-8 pb-24 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="text-sm text-[#8E8E93] max-w-2xl">
            <p className="font-medium text-[#FFC107] mb-2">⚠️ Risk Disclaimer</p>
            <p>
              Trading involves risk. Past performance is not indicative of future results. 
              Always trade with risk capital you can afford to lose.
            </p>
          </div>
          
          <div className="flex flex-col items-start md:items-end gap-2">
            <div className="text-sm text-[#E4E4E5] font-medium flex items-center gap-2">
              <span>Contact Us:</span>
              <a 
                href="https://wa.link/og6izz" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-[#25D366] hover:text-[#1da851] transition-colors bg-[#25D366]/10 px-3 py-1.5 rounded-full"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" height="16" fill="currentColor">
                  <path d="M16 2C8.268 2 2 8.268 2 16c0 2.47.643 4.788 1.77 6.8L2 30l7.38-1.74A13.93 13.93 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.84-1.6l-.42-.25-4.38 1.03 1.06-4.27-.27-.44A11.5 11.5 0 1 1 16 27.5zm6.29-8.63c-.34-.17-2.02-1-2.34-1.11-.32-.11-.55-.17-.78.17-.23.34-.9 1.11-1.1 1.34-.2.23-.4.26-.74.09-.34-.17-1.44-.53-2.74-1.69-1.01-.9-1.69-2.02-1.89-2.36-.2-.34-.02-.53.15-.7.15-.15.34-.4.51-.6.17-.2.23-.34.34-.57.11-.23.06-.43-.03-.6-.09-.17-.78-1.88-1.07-2.58-.28-.68-.57-.59-.78-.6h-.67c-.23 0-.6.09-.91.43-.31.34-1.2 1.17-1.2 2.85s1.22 3.3 1.4 3.53c.17.23 2.42 3.7 5.86 5.19.82.35 1.46.56 1.95.72.82.26 1.57.22 2.16.13.66-.1 2.02-.82 2.31-1.62.29-.8.29-1.48.2-1.62-.09-.14-.31-.23-.65-.4z"/>
                </svg>
                <span>WhatsApp</span>
              </a>
            </div>
            <div className="text-sm text-[#52525B]">
              © {new Date().getFullYear()} Kairosis Capital. All rights reserved.
            </div>
          </div>
        </div>
      </div>
      <CompanyFooter />
    </footer>
  );
}